module.exports = {
      id: "ic-rsi-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-rsi-usage",
      toString: function () {
        return this.url;
      }
    }